import React from "react";

type MeetingsCustomButtonProps = {
  variant: "SMALL" | "LARGE";
  type: "JOIN" | "CANCEL";
  onClick: () => void;
  customText?: string;
  className?: string;
  disabled?: boolean;
};

export const MeetingsCustomButton: React.FC<MeetingsCustomButtonProps> = ({
  variant,
  type,
  onClick,
  customText,
  className,
  disabled = false,
}) => {
  const getClassName = (arg: string) => {
    switch (arg) {
      case "SMALL":
        return "MeetingsCustomButton__small";
      case "LARGE":
        return "MeetingsCustomButton__large";
      case "JOIN":
        return "MeetingsCustomButton__join";
      case "CANCEL":
        return "MeetingsCustomButton__cancel";
    }
  };

  return (
    <div
      className={`MeetingsCustomButton ${getClassName(variant)} ${getClassName(
        type
      )} ${className} ${disabled ? "Disabled" : ""}`}
      onClick={onClick}
    >
      {customText ? customText : type === "JOIN" ? "Join" : "Cancel"}
    </div>
  );
};
